import { call, takeLatest, put } from 'redux-saga/effects';
import { addToRootSaga } from 'store';
import { fetchStatsForTimeRange } from 'api/IterableGoalsAPI';

import { Saga } from 'custom-types/saga';
import { GoalPerformanceAction, QueryData } from 'modules/iterableGoals/types';
import { addNegativeToast, errorIdentifier } from 'modules/toastContainer';
import { getCommonTranslations } from 'utils/translations';
import * as actions from '../actions';
import { ActionTypes } from '../actionTypes';

export function* fetchGoalPerformanceSaga({
  queryData,
}: GoalPerformanceAction<{ queryData: QueryData }>): Saga<GoalPerformanceAction> {
  try {
    const metricsResponse = yield call(fetchStatsForTimeRange, queryData);
    yield put(actions.fetchGoalPerformanceResponse(metricsResponse.data));
  } catch (error) {
    const errorMessage = yield call(getCommonTranslations, 'errorMessage.contactCSM');

    yield put(actions.fetchGoalPerformanceError());
    yield put(
      addNegativeToast(
        errorMessage,
        errorIdentifier({
          source: 'fetchGoalPerformanceSaga',
          error,
          additional: queryData,
        }),
      ) as any,
    );
  }
}

addToRootSaga([takeLatest(ActionTypes.FETCH_GOAL_PERFORMANCE_REQUEST, fetchGoalPerformanceSaga)]);
